import { Link, useNavigator } from "@clairejs/react-web";
import { getText, Tlt, useDispatch, useStore } from "@clairejs/react";
import { Button, Col, Dropdown, Row } from "antd";
import { DownOutlined } from "@ant-design/icons";

import freeTextLogo from "../../assets/images/free.svg";

import { DataStore } from "../../store/store";

import { sessionActions } from "../../store/action/session";

import { MutedTextColor } from "../../utils/style";

import StickyHeader from "../../components/sticky-header";
import LoginGroup from "./login-group";
import styled from "styled-components";

const Wrapper = styled.div`
    flex: 1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 21;

    .logo {
        height: 34px;
        object-fit: contain;
    }
`;
export default function Header() {
    const navigator = useNavigator();

    const me = useStore(DataStore, (s) => s.me);

    const dispatch = useDispatch(DataStore);

    const logout = async () => {
        await dispatch(sessionActions.logout());
        navigator.navigate("/");
    };

    const showRegister = ["/", ""].includes(navigator.getPath());

    return (
        <StickyHeader
            id="sticky-header"
            height={89}
            render={
                <Wrapper className="div-wrapper">
                    <div
                        style={{
                            display: "flex",
                            gap: 5,
                            alignItems: "flex-end",
                            flexWrap: "wrap",
                        }}>
                        <Link to="/" style={{ marginRight: 8 }}>
                            <img className="logo" alt="logo" src={freeTextLogo} />
                        </Link>
                        <div
                            style={{
                                fontSize: 14,
                                color: MutedTextColor,
                                whiteSpace: "pre",
                                marginBottom: -3,
                            }}>
                            <Tlt id="slogan" />
                        </div>
                    </div>
                    <div>
                        {me?.hasToken && (
                            <div>
                                <Dropdown
                                    arrow
                                    placement="bottomRight"
                                    trigger={["click"]}
                                    menu={{
                                        items: [
                                            {
                                                key: "admin",
                                                type: "item",
                                                label: getText(<Tlt template="Admin console" />),
                                                onClick: () => {
                                                    navigator.navigate("/admin");
                                                },
                                            },
                                            {
                                                key: "logout",
                                                type: "item",
                                                label: getText(<Tlt template="Sign out" />),
                                                onClick: () => logout(),
                                            },
                                        ],
                                    }}>
                                    <Button icon={<DownOutlined />} type="link">
                                        <Tlt
                                            template="Hello, {user}"
                                            data={{ user: me.info?.displayName || me.info?.email || "" }}
                                        />
                                    </Button>
                                </Dropdown>
                            </div>
                        )}
                        {showRegister && me && !me.hasToken && (
                            <Row>
                                <Col xs={0} md={24}>
                                    <LoginGroup />
                                </Col>
                            </Row>
                        )}
                    </div>
                </Wrapper>
            }
        />
    );
}
